<template>
  <div>
    <div v-if="displayTime" class="time-reminder">
      <div class="time">{{message.timestamp | date('MM-DD HH:mm')}}</div>
    </div>
    <div :class="['chat-box', isMine ? 'mine' : 'other']">
      <div class="avatar-icon">
        <template v-if="message.from === roomInfo.recruiter.pid">
          <img class="avatar" src="../assets/images/avatar_company.svg" alt="">
        </template>
        <template v-if="message.from === roomInfo.seeker.pid">
          <img class="avatar" v-if="roomInfo.seeker.avatar" :src="roomInfo.seeker.avatar" />
          <img class="avatar" v-else src="../assets/images/img_user_default.svg" />
        </template>
      </div>
      <div class="chat-content">
        <div class="chat-wrap">
          <div class="chat-msg">{{message.text}}</div>
          <!-- <div class="remark">已读</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.font (@size, @weight, @color, @lineHeight) {
  font-size: @size;
  font-weight: @weight;
  color: @color;
  line-height: @lineHeight;
}
// 时间提醒
.time-reminder {
  text-align: center;
  .time {
    .font(14px, 400, rgba(255, 255, 255, 1), 20px);
    display: inline-block;
    padding: 2px 10px;
    background: rgba(221, 221, 221, 1);
    border-radius: 4px;
    margin-bottom: 15px;
  }
}
.chat-box {
  position: relative;
  padding: 0 50px;
  &:not(:last-child) {
    margin-bottom: 15px;
  }
  .avatar-icon {
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    .avatar {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
  .chat-content {
    .chat-wrap {
      .chat-msg {
        display: inline-block;
        padding: 15px;
        margin-bottom: 5px;
        white-space: pre-wrap;
      }
      .remark {
        .font(12px, 400, rgba(153, 153, 153, 1), 17px);
        margin-bottom: 10px;
      }
    }
  }
}
// 对方
.other {
  .avatar-icon {
    left: 0;
  }
  .chat-msg {
    background: rgba(255, 255, 255, 1);
    border-radius: 0px 10px 10px 10px;
    border: 1px solid rgba(232, 232, 232, 1);
  }
}
// 我方
.mine {
  .avatar-icon {
    right: 0;
  }
  .chat-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .chat-msg {
      background: rgba(216, 239, 255, 1);
      border-radius: 10px 0px 10px 10px;
      border: 1px solid rgba(186, 213, 232, 1);
      float: right;
    }
    .remark {
      text-align: right;
    }
  }
}
</style>

<script>
export default {
  name: 'Message',
  props: {
    roomInfo: Object,
    message: Object,
    previousMessage: Object,
    nextMessage: Object,
    lastDeliveredAt: String,
    lastReadAt: String,
    isMine: Boolean
  },
  data() {
    return {
      displayTime: false
    };
  },
  mounted() {
    if (!this.previousMessage) {
      this.$set(this, 'displayTime', true);
    } else if (this.previousMessage.timestamp) {
      const thisMinute = Math.floor(this.message.timestamp / 60000);
      const previousMinute = Math.floor(this.previousMessage.timestamp / 60000);
      if (thisMinute !== previousMinute) {
        this.$set(this, 'displayTime', true);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Message.vue